import { render, staticRenderFns } from "./CardMensageria.vue?vue&type=template&id=4253dbb8&scoped=true"
import script from "./CardMensageria.vue?vue&type=script&lang=js"
export * from "./CardMensageria.vue?vue&type=script&lang=js"
import style0 from "./CardMensageria.vue?vue&type=style&index=0&id=4253dbb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4253dbb8",
  null
  
)

export default component.exports